<div class="container-fluid mt-4">
  <div class="card">
    <div class="card-header">
      <h3>Journeys</h3>
      <fa-icon class="card-header-icon bg-gradient-primary text-white" icon="route" size="lg" [fixedWidth]="true"></fa-icon>
    </div>
    <div *ngIf="!journeys" class="card-body">Loading...</div>
    <div *ngIf="journeys" class="card-body">
      <ul class="list-group">
        <li class="list-group-item" *ngFor="let j of journeys; let index = index">
          <div class="row">
            <h5>{{ j.name }}</h5>
          </div>
          <div *ngFor="let c of j.children" class="row">
            <div *ngIf="c.node?.path" class="col">
              <app-path-selector [path]="parse(c.node.path)" [readonly]="true"></app-path-selector>
            </div>
            <div *ngIf="!c.node?.path" class="col">
              <span
                class="text-danger"
                ngbTooltip="The node assigned to this journey has been deleted or is not translated for the currently selected language"
              >
                Node missing
              </span>
            </div>
          </div>
          <div>
            <div class="btn-group float-end">
              <button class="btn btn-light" type="button" [disabled]="loading" (click)="navigate(j.uuid)">
                <fa-icon icon="pencil" size="md"></fa-icon>
                Edit
              </button>
              <button class="btn btn-danger" type="button" [disabled]="loading" (click)="remove(j, index)">
                <fa-icon icon="trash" size="md"></fa-icon>
                Delete
              </button>
            </div>
          </div>
        </li>
        <li class="list-group-item">
          <div class="row my-2">
            <div style="width: auto">
              <button class="btn btn-primary" type="button" (click)="navigate('new')">
                <fa-icon [icon]="['fal', 'plus']"></fa-icon>
                Add Journey
              </button>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
